<template>
  <div>
    <v-dialog
      content-class="post-selection-con"
      v-model="postSelectionDialog"
      :overlay-opacity="opacity"
      :persistent="true"
    >
      <div class="post-id-card">
        <!-- header part  -->
        <div class="flex header">
          <div class="flex">
            <v-icon
              @click="handleBackbtn"
              class="icon"
              color="#1F8F58"
              size="25"
            >
              mdi-arrow-left
            </v-icon>
            <h3 class="header-text">Post Selection</h3>
          </div>

          <h3>2/2</h3>
        </div>
        <h3 style="margin-bottom: 15px; font-weight: 500">
          Please paste the Post ID link below
        </h3>
        <v-text-field
          v-model="postUuid"
          :light="true"
          outlined
          placeholder="Post Id"
          color="#121212"
          hide-details="true"
        ></v-text-field>

        <!-- button section  -->
        <div class="button-section flex">
          <v-btn
            @click="handleCancelClick"
            elevation="0"
            class="cancel-btn"
            color="#EBF5F0"
            >Cancel</v-btn
          >
          <v-btn
            @click="handlePublishBtn"
            elevation="0"
            class="next-btn"
            color="#1D8D56"
            :disabled="postUuid.length === 0"
          >
            PUBLISH CAMPAIGN
          </v-btn>
        </div>
      </div>
    </v-dialog>

    <!-- sucess page  -->
    <success-page
      :type="successType"
      :successOverlay="successOverlay"
      @closeAll="closeOverlay"
    />
  </div>
</template>
<script>
import API_URL from "../../../../helpers/apiUrls";
import accessToken from "../../../../helpers/accessToken";
import successPage from "./success-page.vue";
export default {
  name: "post-selection",
  components: {
    "success-page": successPage,
  },
  data() {
    return {
      opacity: 0,
      postUuid: "",
      postSelectionDialog: this.successOverlay,
      successOverlay: false,
      isPostIdpresent: true,
      dataforApi: this.data,
      successType: "published",
    };
  },
  props: {
    postSelectionOverlay: Boolean,
    data: Object,
    fromEditpage: Boolean,
  },
  mounted() {
    console.log("POST Selection MOUNTED");
  },
  watch: {
    data: function () {
      console.log("IN DATA", this.data);
    },
    dataforApi: function () {
      console.log("IN DATA", this.dataforApi);
    },
    postSelectionOverlay: function () {
      this.postSelectionDialog = this.postSelectionOverlay;
    },
  },

  methods: {
    handleBackbtn() {
      this.$emit("closePostSelectionOverlay");
    },
    handleCancelClick() {
      this.$emit("closeAll");
    },
    handlePublishBtn() {
      const seenLocationIds = new Set();
      const uniqueArray = [];
      for (const obj of this.dataforApi.audience_list.location) {
        if (!seenLocationIds.has(obj.location_id)) {
          uniqueArray.push(obj);
          seenLocationIds.add(obj.location_id);
        }
      }
     //console.log("seenLocationIds", seenLocationIds, uniqueArray);
      this.dataforApi.audience_list.location = uniqueArray;
      this.dataforApi.awareness_post_id = this.postUuid;
      if (this.fromEditpage) {
        this.postUuid = "";
        this.$emit("closePostSelectionOverlay");
        this.$emit("campaignPostData", this.dataforApi.awareness_post_id);
      } else {
        this.createcampaign();
      }
    },
    closeOverlay() {
      this.successOverlay = false;
      this.$emit("reloadApi");
    },

    createcampaign() {
      const successHandler = (response) => {
        console.log("response =029-r80298", response);
        if (response.status === 200) {
          console.log("RESPONSE *******", response);
          this.successOverlay = true;
        }
      };

      const errorHandler = (error) => {
        console.log("ERROR ** ", error.response.data);
        if (error.response.data.awareness_post_id) {
          this.showToast(
            error.response.data.awareness_post_id[0],
            "error",
            10000
          );
        } else if (error.response.data.non_field_errors) {
          this.showToast(
            error.response.data.non_field_errors[0],
            "error",
            10000
          );
        } else {
          this.showToast("Something went wrong internally", "error", 10000);
        }

        this.loader = false;
      };

      const headers = {
        Authorization: `Bearer ${accessToken.getAccessToken()}`,
      };
      console.log("DATA FOR API ---->", this.dataforApi);
      this.requestPOST(
        API_URL.createCampaign,
        this.dataforApi,
        headers,
        successHandler,
        errorHandler
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  justify-content: space-between;
  margin-bottom: 15px;
  margin-bottom: 25px;
}
.icon {
  background-color: #eff6f3;
  padding: 8px;
  border-radius: 6px;
}
.header-text {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 1.2rem;
  color: #333333;
  margin-left: 15px;
}

.post-id-card {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 25px;
  color: #333333;
  max-height: 700px;
}
.button-section {
  justify-content: space-between;
  margin-top: 30px;
  .v-btn {
    width: 47%;
    height: 56px !important;
    text-transform: capitalize !important;
    font-size: 1rem;
  }
}
.cancel-btn {
  color: #1d8d56 !important;
  font-size: 1rem;
}
.next-btn {
  color: #ffffff;
  font-size: 1rem;
}
.back-flex {
  color: #1d8d56;
}
.theme--dark.v-btn.v-btn--has-bg {
  background-color: #eff6f3;
}
</style>
<style>
.post-selection-con.v-dialog {
  width: 800px;
  height: 650px;
  background-color: white;
  border-radius: 10px;
  box-shadow: none;
}
</style>
